import { setSelfCartArray } from "./Slices/selfOrderCartSlice";
import store from "../Redux/store";
import { setSelfChairIds, setSelfCustomer, setSelfMobileNo, setSelfOrderScreen, setSelfOrderType, setSelfTableIds, setSelfTableNames, setSelfUpdateIntent } from "./Components/Order/selfOrderEssentialsSlice";
import {  setScreenSelected, setSelfSingleOrderInfo } from "./Slices/selfOrderMainSlice";

  export const selfOrderClear=()=>{
      store.dispatch(setSelfOrderType(null))
      store.dispatch(setSelfOrderScreen(null))
      store.dispatch(setScreenSelected(null))
      store.dispatch(setSelfChairIds([]))
      store.dispatch(setSelfTableIds([]))
      store.dispatch(setSelfTableNames([]))
      store.dispatch(setSelfCartArray([]))
      store.dispatch(setSelfSingleOrderInfo(null))
      store.dispatch(setSelfCustomer(null))
      store.dispatch(setSelfMobileNo(null))
      store.dispatch(setSelfUpdateIntent(false))
      localStorage.removeItem("selfOrderId")
  }

export const getDisplayCurrencySymbol = (currencyDetails) => {
  const symbolRaw = `${currencyDetails?.symbol ?? ""}`.trim();
  const codeRaw = `${currencyDetails?.currencyCode ?? currencyDetails?.code ?? ""}`.trim().toUpperCase();

  if (/[₹$€£¥₩₽฿₺₫₴₦₪₱]/.test(symbolRaw)) return symbolRaw;

  const mappedByCode = {
    INR: "₹",
    USD: "$",
    EUR: "€",
    GBP: "£",
    AED: "Dhs",
    QAR: "Qr.",
    SAR: "SAR",
    OMR: "OMR",
    KWD: "KD",
    BHD: "BHD",
  };

  if (mappedByCode[codeRaw]) return mappedByCode[codeRaw];

  const symUpper = symbolRaw.toUpperCase();
  if (symUpper === "RS" || symUpper === "INR") return "₹";
  if (symUpper === "AED") return "Dhs";
  if (symUpper === "QAR" || symUpper === "QR") return "Qr.";
  if (symUpper === "SAR") return "SAR";
  if (symUpper === "USD") return "$";

  return symbolRaw || codeRaw || "";
};

export const formatCurrencyValue = (value, currencyDetails, decimalPosition) => {
  const dp = Number(decimalPosition ?? 0) || 0;
  const amount = Number(value || 0);
  const formatted = amount.toFixed(dp);
  const symbol = getDisplayCurrencySymbol(currencyDetails);
  const isRight = currencyDetails?.symbolPosition === true;

  if (!symbol) return formatted;
  return isRight ? `${formatted} ${symbol}` : `${symbol} ${formatted}`;
};